import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Contact from '../landing/contact';
import Logo20Scoops from '../../images/Logo-20Scoops.svg';

const FooterWrapper = styled.footer`
  background: ${({ theme, contactShow }) =>
    contactShow ? theme.color.textWhite : theme.color.textWhite};
  padding: 50px 35px;
  box-shadow: inset 0 2px 0 #e0e0e0;
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    padding: 20px 35px 20px 35px;
    display: block;
  }
`;
const LogoWrapper = styled.div`
  display: flex;

  &.left {
    justify-content: start;
    padding: 0 0 0 5%;
    width: 33%;

    @media screen and (max-width: 1440px) {
      justify-content: start;
      padding: 0 0 0 6%;
      width: 30%;
    }

    @media screen and (max-width: ${({ theme }) => theme.device.laptop}) {
      justify-content: start;
      padding: 0 0 0 2%;
      width: 50%;
    }

    @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
      padding: 0;
    }

    @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
      justify-content: center;
      padding: 0;
      width: 100%;
    }

    @media screen and (min-width: 2000px) {
      justify-content: start;
      padding: 0 0 0 8%;
      width: 33%;
    }
  }
  &.middle {
    width: 33%;
    justify-content: center;
    padding-left: 6%;

    @media screen and (max-width: ${({ theme }) => theme.device.laptop}) {
      justify-content: flex-end;
      padding: 0 2% 0 0;
      width: 50%;
    }

    @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
      width: 100%;
      padding: 0px;
      justify-content: center;
    }
  }
  &.right {
    justify-content: flex-end;
    padding: 0 2% 0 0;
    width: 33%;

    @media screen and (max-width: ${({ theme }) => theme.device.laptop}) {
      justify-content: center;
      padding: 37px 0 0 3%;
      width: 100%;
    }

    @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
      justify-content: center;
      width: 100%;
      padding: 0px;
      &.left {
        width: 100%;
      }
      &.middle {
        width: 100%;
      }
      &.right {
        width: 100%;
      }
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    width: 100%;
    margin: 25px 0;
  }
`;
const CustomLogo = styled.img`
  width: 100px;
  vertical-align: middle;
  margin-right: 8px;
`;

const FooterText = styled.span`
  ${({ theme }) => theme.typography.footerContent()};
  position: relative;
  color: ${({ theme }) => theme.color.textFooter};
  vertical-align: middle;
`;

const PrivacyWrapper = styled(Link)`
  ${({ theme }) => theme.typography.footerContent()};
  color: ${({ theme }) => theme.color.textFooter};
  vertical-align: middle;
  text-decoration: none;
  margin: auto 6px;
  text-transform: uppercase;
`;

const CopyrightWrapper = styled.span`
  ${({ theme }) => theme.typography.footerContent()};
  position: relative;
  color: ${({ theme }) => theme.color.textFooter};
  vertical-align: middle;

  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    float: none;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    width: 100%;
  }
`;

const FadeFooterStyle = styled.div`
  position: absolute;
  z-index: 0;
  left: 630px;
  top: -150px;
  height: 2030px;
  width: 2030px;
  background: radial-gradient(
    38.84% 50% at 50% 50%,
    rgba(234, 2, 0, 0.28) 0%,
    rgba(234, 2, 0, 0) 88.2%
  );

  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    left: -651px;
    right: 0;
    top: -14.03%;
    bottom: -117.51%;
    background: radial-gradient(
      38.84% 40% at 50% 60%,
      rgba(234, 2, 0, 0.28) 0%,
      rgba(234, 2, 0, 0) 88.2%
    );
  }

  @media (min-width: 1780px) {
    left: 500px;
  }
  @media (min-width: 2000px) {
    left: 900px;
  }
`;

const BackgroundFooterColor = styled.div`
  position: relative;
  overflow: hidden;
  z-index: 10;
`;

const Footer = ({ contactShow = true }) => {
  return (
    <div
      css={`
        position: relative;
        background-color: ${({ theme }) => theme.color.textWhite};
      `}
    >
      <BackgroundFooterColor>
        {!!contactShow && <FadeFooterStyle />}
        {!!contactShow && <Contact />}
        <FooterWrapper contactShow={contactShow}>
          <LogoWrapper className="left">
            <FooterText>
              <CustomLogo src={Logo20Scoops} />
              ein Unternehmen der 20Scoops
            </FooterText>
          </LogoWrapper>
          <LogoWrapper className="middle">
            <FooterText>
              <PrivacyWrapper to={'/imprint'}>IMPRESSUM</PrivacyWrapper>/
              <PrivacyWrapper to={'/privacy'}>DATENCHUTZ</PrivacyWrapper>
            </FooterText>
          </LogoWrapper>
          <LogoWrapper className="right">
            <CopyrightWrapper>
              © {new Date().getFullYear()} 20SCOOPS. All Rights Reserved
            </CopyrightWrapper>
          </LogoWrapper>
        </FooterWrapper>
      </BackgroundFooterColor>
    </div>
  );
};

export default Footer;
